import * as React from "react";
import Svg, { Line } from "react-native-svg";

const DottedLine = (props) => (
  <Svg
    width={props?.width ? props.width : 304}
    height={1}
    viewBox={`0 0 ${
      props?.width && props.width !== "100%" ? props.width : 304
    } 1`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Line
      y1={0.5}
      x2={props?.width ? props.width : 304}
      y2={0.5}
      stroke="black"
      strokeOpacity={0.2}
      strokeDasharray="2 2"
    />
  </Svg>
);

export default DottedLine;
